import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import {startGame} from 'app/services/CasinoServices';
import {size380x380} from 'app/utils/CasinoGameImages';
import {isGuest} from 'app/utils';
import {SignInButton} from 'app/components/auth/SignInButton';
import {CasinoGameInterface} from 'app/interfaces/stores/CasinoGamesStoreInterfaces';

interface CasinoRandomSlotCardProps {
    game: CasinoGameInterface;
    isSelected: boolean;
    setIframeGridPlacement: () => void;
}

const CasinoRandomSlotCard = ({
    game,
    isSelected,
    setIframeGridPlacement
}: CasinoRandomSlotCardProps): React.ReactNode => {
    const {provider_name, identifier, restricted, id, identifier2, name, released_at} = game;
    const cardClassName = isSelected
        ? 'casino-random-slot__card casino-random-slot__card--selected'
        : 'casino-random-slot__card';

    const handlePlayClick = useCallback((): void => {
        if (restricted) {
            return;
        }

        setIframeGridPlacement();
        startGame(id, null);
    }, [
        restricted,
        id,
        setIframeGridPlacement
    ]);

    return (
        <div className={cardClassName}>
            <img
                alt={identifier2 || name}
                src={size380x380(provider_name, identifier, released_at)}
                className="casino-random-slot__card-image"
                draggable={false}
            />
            {isSelected && <div className="casino-random-slot__card-play">
                {isGuest()
                    ? <SignInButton
                        title={I18n.t('play')}
                        usingOnTab="CASINO"
                        className="casino-random-slot__play-btn"
                    />
                    : <button
                        type="button"
                        className="casino-random-slot__play-btn"
                        onClick={handlePlayClick}
                    >
                        {I18n.t('play')}
                    </button>}
            </div>}
        </div>
    );
};

export default React.memo(CasinoRandomSlotCard);
